var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content queryInvoice" },
    [
      _c(
        "search-item",
        {
          key: _vm.identify,
          ref: _vm.identify,
          attrs: {
            "is-append-query": _vm.isAppendQuery,
            "show-more-scheme": true,
            "show-simple": _vm.showSimple,
            "expand-adv": true,
            "search-item-code": _vm.searchItemCode,
            "config-module": _vm.configModule,
            "grid-config-module": _vm.gridConfigModule,
            "auto-init": _vm.searchItemAutoInit,
            "custom-search-items": _vm.customSearchItems,
            "custom-sim-query-placeholder": _vm.simQueryPlaceholder,
            "col-settings": _vm.colSettings
          },
          on: {
            advSearchItemCallBack: _vm.fetchData,
            simSearchItemCallBack: _vm.fetchDataBykeyWord,
            advToggle: _vm.scrollCallback,
            perConfigChange: function(value) {
              _vm.perConfigName = value
            },
            refreshGrid: function() {
              _vm.gridRefreshId += 1
            },
            defaultSearchItemsChange: function(value) {
              _vm.defaultSearchItems = value
            }
          }
        },
        [
          _c("template", { slot: "operations" }, [_vm._t("operations")], 2),
          _c(
            "template",
            { slot: "searchAreaHeader" },
            [_vm._t("searchAreaHeader")],
            2
          )
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid-wrapper", {
            attrs: {
              "config-module": _vm.gridConfigModule,
              "per-config-name": _vm.perConfigName,
              "refresh-id": _vm.gridRefreshId,
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.finalColumnDefs,
              "row-data": _vm.rowData,
              "show-row-groups": _vm.dataListDragGroup,
              "min-height": _vm.hasVoucher === 0 ? "350px" : "200px"
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pagination-wrapper",
          attrs: { id: "footer-wrapper-tab-invoice" }
        },
        [
          _c(
            "div",
            {
              class: [_vm.shouldFixed ? "fixedBottom" : ""],
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "flex-wrap": "wrap"
              }
            },
            [
              _vm.dataShow &&
              ["Writeoff"].includes(_vm.viewSource) &&
              !_vm.totalAmountToCurrencyInvoiceGrid.hidePop
                ? _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.totalAmountToCurrencyInvoiceGrid.labelText
                      )
                    }
                  })
                : _vm._e(),
              (["Writeoff"].includes(_vm.viewSource) &&
                !_vm.totalAmountToCurrencyInvoiceGrid.hidePop) ||
              ["VoucherList"].includes(_vm.viewSource)
                ? _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.totalAmountToCurrencyInvoiceGrid.selectionCountLabel
                      )
                    }
                  })
                : _vm._e(),
              (_vm.reCalc &&
                ["Writeoff"].includes(_vm.viewSource) &&
                  !_vm.totalAmountToCurrencyInvoiceGrid.hidePop) ||
              ["VoucherList"].includes(_vm.viewSource)
                ? _c("charge-currency-total-group", {
                    key: 1,
                    attrs: {
                      "amount-to-currency": _vm.localCurrency,
                      mode: "group",
                      type: _vm.totalType,
                      "data-provider":
                        _vm.totalAmountToCurrencyInvoiceGrid.dataProvider,
                      "data-field": _vm.totalDataField,
                      "currency-field": _vm.totalCurrencyField,
                      "rate-field": _vm.rateField,
                      "ar-field": _vm.arField,
                      "arap-group": _vm.arapGroup,
                      "show-wht": _vm.showWht
                    }
                  })
                : _vm._e(),
              _vm.showTotalUnverifiedAmount &&
              ["Writeoff"].includes(_vm.viewSource) &&
              !_vm.totalAmountToCurrencyInvoiceGrid.hidePop
                ? _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.totalAmountNotWrittenOffLabel)
                    }
                  })
                : _vm._e(),
              _vm.reCalc &&
              _vm.showTotalUnverifiedAmount &&
              ["Writeoff"].includes(_vm.viewSource) &&
              !_vm.totalAmountToCurrencyInvoiceGrid.hidePop
                ? _c("charge-currency-total-group", {
                    key: 2,
                    attrs: {
                      "amount-to-currency": _vm.localCurrency,
                      mode: "group",
                      type: _vm.totalType,
                      "data-provider":
                        _vm.totalAmountToCurrencyInvoiceGrid.dataProvider,
                      "data-field": "unverifiedAmount",
                      "currency-field": _vm.totalCurrencyField,
                      "rate-field": _vm.rateField,
                      "ar-field": _vm.arField,
                      "arap-group": _vm.arapGroup,
                      "show-wht": _vm.showWht
                    }
                  })
                : _vm._e(),
              _vm.reCalc && ["MakeInvoice"].includes(_vm.viewSource)
                ? _c("charge-count-group", {
                    key: 3,
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyInvoiceGrid.selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyInvoiceGrid.dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyInvoiceGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": _vm.alwaysShow,
                      "new-currency-code": true
                    },
                    on: { hidePop: _vm.hidePopHandler }
                  })
                : _vm._e(),
              _vm.reCalc && ["Writeoff"].includes(_vm.viewSource)
                ? _c("charge-count-group", {
                    key: 3,
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyInvoiceGrid.selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyInvoiceGrid.dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyInvoiceGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": _vm.alwaysShow,
                      "new-by-job": 4
                    },
                    on: { hidePop: _vm.hidePopHandler }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.appendQuery,
                  expression: "appendQuery"
                }
              ],
              staticClass: "pagination-container"
            },
            [
              _c("el-pagination", {
                staticStyle: { "text-align": "left" },
                attrs: { total: _vm.searchConditions.total, layout: "total" }
              })
            ],
            1
          ),
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.appendQuery,
                expression: "!appendQuery"
              }
            ],
            ref: "paginationInvoice",
            attrs: {
              "config-module": _vm.gridConfigModule,
              total: _vm.searchConditions.total,
              page: _vm.searchConditions.pageNum,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.searchConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: _vm.fetchDataByPage
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }